import { connect } from 'react-redux'
import {loginUser, handleSignOut} from '../../store/user/duck'
import {addAgentDay, getAvailability, clearPhase} from '../../store/agent/duck'
import AvailabilityForm from './component'
const Availability = connect(
  // Map state to props
  (state) => ({
    user: state.user.users,
    isSubmitting: state.user.isSubmitting,
    rxError: state.user.error,
    phase: state.user.phase,
    getAvilData: state.agent.getAvilData,
    getAvilPhase: state.agent.getAvilPhase,
    addAgentDayPhase: state.agent.addAgentDayPhase
  }),
  // Map actions to props
  {
    loginUser,
    handleSignOut,
    addAgentDay,
    getAvailability,
    clearPhase
  }
)(AvailabilityForm)
export default Availability
